import { grey, red } from "@mui/material/colors";

const styles = {
  dialog: {
    borderRadius: "16px",
  },
  mainContainer: {
    padding: "26px",
    minWidth: "600px",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 26,
  },
  infoSection: {
    marginBottom: 0,
    paddingBottom: "16px",
  },
  ticketUserInfoContainer: {
    borderRadius: "8px",
    // padding: "16px",
    paddingBottom: "16px",
    marginBottom: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    // backgroundColor: grey[50],
  },
  ticketUserInfoLeft: {
    display: "flex",
    flexDirection: "column",
  },
  ticketUserInfoRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    gap: 16,
  },
  ticketUserInfoLeftContainer: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  receiptIconContainer: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    backgroundColor: grey[200],
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  receiptIcon: {
    color: grey[600],
  },
  ticketInfoColumn: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
    alignItems: "flex-start",
  },
  ticketInfoLabel: {
    fontSize: "11px",
    color: grey[600],
    fontWeight: 500,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  ticketInfoValue: {
    fontSize: "14px",
    color: grey[800],
    fontWeight: 500,
    marginBottom: 8,
  },
  statusContainer: {
    display: "flex",
    alignItems: "center",
  },
  ticketMainInfoContainer: {
    backgroundColor: grey[100],
    borderRadius: "8px",
    padding: "10px",
    marginBottom: 24,
    
  },
  infoLabel: {
    fontSize: "11px",
    color: grey[600],
    fontWeight: 500,
    marginBottom: 4,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  nameLabel: {
    fontSize: "18px",
    color: grey[800],
    fontWeight: 700,
  },
  typeUserLabel: {
    fontSize: "14px",
    color: grey[500],
    fontWeight: 400,
  },
  infoValue: {
    fontSize: "16px",
    color: grey[800],
    fontWeight: 400,
  },
  commentSection: {
    marginTop: 24,
    marginBottom: 24,
  },
  commentLabel: {
    fontSize: "11px",
    color: grey[600],
    fontWeight: 500,
    marginBottom: 8,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  commentBox: {
    backgroundColor: grey[50],
    borderRadius: "8px",
    padding: "16px",
    border: `1px solid ${grey[200]}`,
  },
  commentValue: {
    fontSize: "14px",
    color: grey[800],
    fontWeight: 400,
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
  },
  imagesSection: {
    marginTop: 24,
    marginBottom: 24,
  },
  imagesSectionLabel: {
    fontSize: "16px",
    color: grey[800],
    fontWeight: 800,
    marginBottom: 16,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  imageCard: {
    cursor: "pointer",
    borderRadius: "8px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  cardMedia: {
    height: 180,
    objectFit: "cover",
  },
  imageCardContent: {
    padding: "12px !important",
    flexGrow: 1,
  },
  imageCardTitle: {
    fontSize: "12px",
    color: grey[700],
    fontWeight: 500,
    textAlign: "center",
  },
  pdfContainer: {
    height: 180,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: grey[100],
  },
  pdfIcon: {
    color: grey[600],
  },
  imageDialog: {
    borderRadius: "16px",
    maxWidth: "90vw",
    maxHeight: "90vh",
    width: "auto",
  },
  imageDialogHeader: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "8px 8px 0 8px",
    position: "relative",
  },
  imageDialogContent: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    width: "fit-content",
  },
  closeImageButton: {
    padding: "4px",
  },
  downloadImageButton: {
    padding: "4px",
  },
  fullSizeImage: {
    maxWidth: "90vw",
    maxHeight: "85vh",
    width: "auto",
    height: "auto",
    objectFit: "contain",
    borderRadius: "8px",
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "end",
    width: "100%",
    padding: 0,
    marginTop: 36,
    gap: 12,
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  activeButton: {
    width: "180px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "180px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  circularProgress: {
    color: "white",
  },
};

export default styles;

